import { useState, useEffect } from "react";

function App() {
  const [notes, setNotes] = useState(() => {
    const storedNotes = localStorage.getItem("my-notes");
    return storedNotes ? JSON.parse(storedNotes) : [];
  });
  const [inputNote, setInputNote] = useState("");

  function handleInputChange(e) {
    setInputNote(e.target.value);
  }
  const [editNoteId, setEditNoteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  // ⬇️ 2. Load dari localStorage saat pertama kali render
  useEffect(() => {
    const storedNotes = localStorage.getItem("my-notes");
    if (storedNotes) {
      setNotes(JSON.parse(storedNotes));
    }
  }, []);

  // ⬆️ 1. Simpan ke localStorage setiap kali notes berubah
  useEffect(() => {
    localStorage.setItem("my-notes", JSON.stringify(notes));
  }, [notes]);

  useEffect(() => {
    document.body.className = isDarkMode ? "dark" : "light";
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  function handleSubmit(e) {
    e.preventDefault();

    if (inputNote.trim() === "") return;

    if (editNoteId !== null) {
      // mode edit
      const updatedNotes = notes.map((note) =>
        note.id === editNoteId ? { ...note, text: inputNote } : note
      );
      setNotes(updatedNotes);
      setEditNoteId(null); // reset edit mode
    } else {
      // mode tambah
      const newNote = {
        id: new Date().getTime(),
        text: inputNote,
        completed: false,
      };
      setNotes([...notes, newNote]);
    }

    setInputNote("");
  }

  function handleEditNote(note) {
    setEditNoteId(note.id);
    setInputNote(note.text);
  }

  function handleDeleteNote(id) {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this note?"
    );
    if (!confirmDelete) return;

    const updatedNotes = notes.filter((note) => note.id !== id);
    setNotes(updatedNotes);

    setToastMessage("Note deleted!");
    setTimeout(() => {
      setToastMessage("");
    }, 3000);
  }

  function handleToggleCompleted(id) {
    const updatedNotes = notes.map((note) =>
      note.id === id ? { ...note, completed: !note.completed } : note
    );
    setNotes(updatedNotes);
  }

  return (
    <>
      <div className={`App ${isDarkMode ? "dark" : "light"}`}>
        <h1>Notes App</h1>
        {toastMessage && (
          <div className={`toast ${isDarkMode ? "dark" : "light"}`}>
            {toastMessage}
          </div>
        )}

        <div className="changeTheme">
          <button onClick={toggleTheme}>
            {isDarkMode ? "Light Mode" : "Dark Mode"}
          </button>
        </div>
        <form className="note-input" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Add a note"
            value={inputNote}
            onChange={handleInputChange}
          />
          <button>{editNoteId !== null ? "Save" : "Add"}</button>
        </form>
        <input
          type="text"
          placeholder="Search notes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <ul className="note-list">
          {notes
            .filter((note) =>
              note.text.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((note) => (
              <li key={note.id}>
                <span
                  style={{
                    textDecoration: note.completed ? "line-through" : "none",
                    color: note.completed ? "gray" : "black",
                  }}
                >
                  {note.text}
                </span>
                <div className="note-actions">
                  <button onClick={() => handleToggleCompleted(note.id)}>
                    {note.completed ? "Undo" : "Done"}
                  </button>
                  <button onClick={() => handleDeleteNote(note.id)}>
                    Delete
                  </button>
                  <button onClick={() => handleEditNote(note)}>Edit</button>
                </div>
              </li>
            ))}
        </ul>
      </div>
      <div className="footer">
        <footer>
          Practice project from Codepolitan. Modified by Gilang Abdian, 2025.
        </footer>
      </div>
    </>
  );
}

export default App;
